import { render, staticRenderFns } from "./IPO.vue?vue&type=template&id=e9242c88&scoped=true"
import script from "./IPO.vue?vue&type=script&lang=js"
export * from "./IPO.vue?vue&type=script&lang=js"
import style0 from "./IPO.vue?vue&type=style&index=0&id=e9242c88&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9242c88",
  null
  
)

export default component.exports